import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Switch from '@ui/switch/switch';

interface ToggleProps {
  label?: string;
  value: boolean;
  sKey: string;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  onToggle: (val: string, on: boolean) => void;
  onLabel?: string;
  offLabel?: string;
  padding?: string;
}

const SettingsToggle = ({
  label,
  value,
  sKey,
  disabled = false,
  fullWidth = false,
  onToggle,
  padding = '16px',
}: ToggleProps) => {
  return (
    <Container
      padding={padding}
      background="var(--gray-900)"
      height="52px"
      borderRadius="8px"
      width={fullWidth ? '100%' : 'auto'}
      className={`flex ${fullWidth ? 'fd-row' : 'ai-center jc-space-between'}`}
      opacity={disabled ? 0.5 : 1}
    >
      {!fullWidth && (
        <Text tag="h6" className="H6">
          {label}
        </Text>
      )}
      <div style={{ flex: fullWidth ? 1 : 'unset', display: fullWidth ? 'flex' : 'block', marginTop: 'auto' }}>
        <Switch on={value || false} onClick={onToggle} value={sKey} disabled={disabled} />
      </div>
    </Container>
  );
};

export default SettingsToggle;
